import React, { useCallback, useState } from "react";
import { DispatchTableEvent, DispatchTransactionEvent } from "../events/events";
import {
  ShowError, confirmationDialog, 
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, 
  JSON_KEY_SUBMITTER, 
  JSON_KEY_INSTRUMENT,
  DELETE_TABLE,
  HOLDINGS_TABLE,
  JSON_KEY_TRADING_ACCOUNT,
  EVENT_TYPE_HOLDINGS_REQUEST,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSG_TYPE_HOLDINGS_SEARCH_REQUEST } from "../../common/msg_types";
import { RenderDropdown } from "../../common/utilies";

const ITEM_TRADING_ACCOUNT_AND_INSTRUMENT = "trading_account_and_instrument";

const HoldingsRequestForm = ({ onClose, tradingAccountOptions, holdingsOptions }) => {
   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   const [instrumentCode, setInstrumentCode] = useState("");
   const [tradingAccountCode, setTradingAccountCode] = useState("");
   const [removeExistingRows, setRemoveExistingRows] = useState(false);

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onTradingAccountDropDownChange = useCallback((e) => setTradingAccountCode(e.target.value), [setTradingAccountCode]);
   const onInstrumentDropDownChange = useCallback((e) => setInstrumentCode(e.target.value), [setInstrumentCode]);

   const ConfirmAndSubmit = async ({ title, text, item }) => {
      const confirmed = await confirmationDialog({ title, text });
      if (confirmed) handleStatusConfirmationSubmit(item);
   };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const base = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_MESSAGE_TYPE]: MSG_TYPE_HOLDINGS_SEARCH_REQUEST,
         [JSON_KEY_TRADING_ACCOUNT]: tradingAccountCode,
      };

      if (instrumentCode && instrumentCode !== "") {
         base[JSON_KEY_INSTRUMENT] = instrumentCode;
      }

      switch (submitItem) {
         case ITEM_TRADING_ACCOUNT_AND_INSTRUMENT:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_HOLDINGS_REQUEST,
               base);
            break;

         default:
            console.log("Holdings Request unknown submit item");
      }

      if (removeExistingRows) {
         // console.log("Holdings Request Form: remove existing rows option selected.");
         DispatchTableEvent(DELETE_TABLE, HOLDINGS_TABLE, "");
      }
   };

   const handleUserAndInstrumentSubmit = () => {
      if (tradingAccountCode === undefined || !tradingAccountCode) return ShowError("Trading Account code is missing");

      ConfirmAndSubmit({
         title: "Holdings Request",
         text: `Request for holdings, trading account: ${tradingAccountCode} and instrument ${instrumentCode}`,
         item: ITEM_TRADING_ACCOUNT_AND_INSTRUMENT,
      });

      onClose(); // your modal close function
   };

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Holdings Request</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Trade Account & Instrument</Tab>
            </TabList>

            {/* Tab 1: Request by trade account and instrument */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleUserAndInstrumentSubmit)}>
               <div className="top">
                  {RenderDropdown("Trade Account", tradingAccountCode, tradingAccountOptions, onTradingAccountDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Instrument", instrumentCode, holdingsOptions, onInstrumentDropDownChange)}
               </div>

               <div >
                  <label className="form-label">
                     Remove Existing Holdings { }
                     <input
                        type="checkbox"
                        style={{ transform: 'scale(2)', margin: '10px' }} 
                        checked={removeExistingRows}
                        onChange={(e) => setRemoveExistingRows(e.target.checked)}
                     />
                  </label>
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
         </Tabs>
         </div>
      </div>
   );
};

export default HoldingsRequestForm;
